import script from "./OpenWorkOrdersReport.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenWorkOrdersReport.vue?vue&type=script&setup=true&lang=js"

import "./OpenWorkOrdersReport.vue?vue&type=style&index=0&id=2b140ce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b140ce8"]])

export default __exports__